var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("iframeItem", {
        attrs: { urlPath: _vm.urlPath, "is-no-container": "" },
        on: { onReadyLoad: _vm.onReadyLoad },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }